import { getString } from '@/util/Strings';

export function useStrings() {
  function t(key: string, replacements: Record<string, string | number> | null = null, defaultValue = '<unknown string>') {
    let result = getString(key) ?? defaultValue
    if (!replacements) {
      return result
    }

    // Replace all given replacements. This works similar to drupal's t() function.
    return Object.entries(replacements).reduce((result, keyValue) => {
      return result.replace(new RegExp(`${keyValue[0]}`), String(keyValue[1]))
    }, result)
  }

  return {
    t,
  }
}
